// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"76f0f118","665":"5d04d512","674":"74661349"}[chunkId] + ".chunk.js";
};